// Auto-generated by scripts/validate-translations.mjs --fix
// Placeholder prefix: __MISSING_TRANSLATION__
// Fallback entries generated: 1266
// Placeholder entries generated: 0
const translationAutofill = {
  "ar": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  },
  "de": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  },
  "en": {},
  "es": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  },
  "fr": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  },
  "pt": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  },
  "zh": {
    "aiAvatarGeneratorTitle": "Avatar Generator",
    "aiCaptionGeneratorTitle": "AI Instagram Caption Generator",
    "aiCaptionInput": "Example: Summer coffee reel for my cafe",
    "aiCartoonGeneratorTitle": "Cartoon Generator",
    "aiCategoryChatTools": "AI Chat Tools",
    "aiCategoryGames": "AI Games",
    "aiCategoryImageTools": "AI Image Tools",
    "aiCategoryTextTools": "AI Text Tools",
    "aiChatInputPlaceholder": "Ask a question or describe your task...",
    "aiChatbotTitle": "AI Chatbot",
    "aiCodingAssistantTitle": "Coding Assistant",
    "aiCodingPromptPlaceholder": "Example: Fix this React hook dependency warning",
    "aiCopyResult": "Copy result",
    "aiDungeonPlaceholder": "Example: cursed temple, lava cave, frozen castle...",
    "aiDungeonSubtitle": "Generate dungeon turns and pick your action in every round.",
    "aiDungeonTitle": "AI Dungeon",
    "aiEmailPromptPlaceholder": "Example: Follow-up email after project proposal",
    "aiEmailWriterTitle": "Email Writer",
    "aiEnglishPracticeTitle": "English Practice",
    "aiEnglishPromptPlaceholder": "Example: Check and improve this sentence",
    "aiFinderCategoryAriaLabel": "Filter tools by category",
    "aiFinderKeywordsDetected": "Detected keywords",
    "aiFinderLiveRanking": "Live relevance ranking",
    "aiFinderLoadError": "Unable to load tool recommendations right now. Please try again.",
    "aiFinderLoadMore": "Load more recommendations",
    "aiFinderLoading": "Loading AI tools...",
    "aiFinderNav": "AI Finder",
    "aiFinderNoResults": "No matching tools found. Try another keyword or category.",
    "aiFinderNone": "none",
    "aiFinderSearchAriaLabel": "Describe what you want to do",
    "aiFinderSearchPlaceholder": "Describe your goal (e.g., write a blog post, generate product video)",
    "aiFinderSeoDescription": "Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.",
    "aiFinderSeoTitle": "AI Finder: Smart AI Tool Recommendations | 3ToolsPro",
    "aiFinderSubtitle": "Describe your task and get ranked AI tool recommendations instantly.",
    "aiFinderTitle": "AI Tool Finder",
    "aiGameApiFallback": "Live AI is temporarily unavailable, showing offline game content.",
    "aiGameCopied": "Copied!",
    "aiGameFeature1": "Mobile-first gameplay with tap-friendly controls",
    "aiGameFeature2": "API-backed AI generation with offline fallback",
    "aiGameFeature3": "Shareable outputs for social traffic boosts",
    "aiGameGenerate": "Generate round",
    "aiGameGenerating": "Generating...",
    "aiGameShare": "Share result",
    "aiGameTopicLabel": "Game topic (optional)",
    "aiGenerate": "Generate",
    "aiGenerating": "Generating...",
    "aiGenericPromptPlaceholder": "Describe what you want to generate...",
    "aiGrammarCheckerTitle": "Grammar Checker",
    "aiGuessTheCharacterPlaceholder": "Example: superhero, anime legend, movie icon...",
    "aiGuessTheCharacterSubtitle": "Get clue-based character challenges and test your friends.",
    "aiGuessTheCharacterTitle": "AI Guess The Character",
    "aiHashtagGeneratorTitle": "Hashtag Generator",
    "aiHistoryEmpty": "No AI history yet. Run any tool to save a local history item.",
    "aiHistorySubtitle": "Saved in localStorage on this device.",
    "aiHistoryTitle": "Recent AI history",
    "aiHomeworkHelperTitle": "Homework Helper",
    "aiHomeworkPromptPlaceholder": "Example: Explain photosynthesis for class 7",
    "aiImageGeneratorTitle": "AI Image Generator",
    "aiImageInput": "Example: Neon city skyline at sunrise, cinematic",
    "aiImageProviderLabel": "Image provider",
    "aiInputRequired": "Please enter a prompt before generating.",
    "aiLogoGeneratorTitle": "Logo Generator",
    "aiParagraphInput": "Paste your paragraph here...",
    "aiParagraphRewriterTitle": "Paragraph Rewriter",
    "aiProductDescriptionTitle": "Product Description Generator",
    "aiProductPromptPlaceholder": "Example: Organic skincare serum for dry skin",
    "aiPromptEnhancerTitle": "Prompt Enhancer",
    "aiProviderLabel": "Text provider",
    "aiQuizGamePlaceholder": "Example: football trivia, JavaScript basics, movies...",
    "aiQuizGameSubtitle": "Build quick quizzes on any topic and challenge your audience.",
    "aiQuizGameTitle": "AI Quiz Game",
    "aiQuizGeneratorTitle": "AI Quiz Generator",
    "aiQuizInput": "Example: JavaScript basics for beginners",
    "aiRiddleGeneratorPlaceholder": "Example: animals, school, travel, food...",
    "aiRiddleGeneratorSubtitle": "Produce clever riddles in seconds for fun challenges.",
    "aiRiddleGeneratorTitle": "AI Riddle Generator",
    "aiRoastMePlaceholder": "Example: my gamer friend, my coding team, me...",
    "aiRoastMeSubtitle": "Generate playful roasts that stay light-hearted and funny.",
    "aiRoastMeTitle": "AI Roast Me",
    "aiStatusDone": "Done. You can copy the result now.",
    "aiStatusGenerating": "Generating response...",
    "aiStatusRetrying": "Retrying provider connection...",
    "aiStoryAdventurePlaceholder": "Example: lost city, space pirates, dragon school...",
    "aiStoryAdventureSubtitle": "Create magical branching story moments instantly with AI.",
    "aiStoryAdventureTitle": "AI Story Adventure",
    "aiStoryGeneratorTitle": "AI Story Generator",
    "aiStoryInput": "Example: A robot that opens a bakery in Cairo",
    "aiStyleTransferTitle": "Style Transfer",
    "aiTextGeneratorTitle": "AI Text Generator",
    "aiTextSummarizerTitle": "Text Summarizer",
    "aiToolsPhase4Subtitle": "Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.",
    "aiUsageLimitLabel": "Usage limit",
    "aiYoutubePromptPlaceholder": "Example: React performance optimization tutorial",
    "aiYoutubeTitleGeneratorTitle": "YouTube Title Generator",
    "and": "and",
    "appLoadingExperience": "Loading experience...",
    "ariaBreadcrumb": "breadcrumb",
    "ariaGoToNextPage": "Go to next page",
    "ariaGoToPreviousPage": "Go to previous page",
    "ariaNextSlide": "Next slide",
    "ariaPagination": "pagination",
    "ariaPreviousSlide": "Previous slide",
    "backToTools": "Back to tools",
    "category": "Category",
    "categoryArticleLinkContentSeo": "How to improve content SEO",
    "categoryArticleLinkProductivity": "Best free productivity tools",
    "categoryNotFound": "Category not found",
    "close": "Close",
    "configAccessDesc": "Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.",
    "contactEmailAddress": "EslamMamdouh619@gmail.com",
    "copyResult": "Copy result",
    "days": "days",
    "daysToBirthday": "Days to next birthday",
    "gameStart": "Start",
    "gameTime": "Time",
    "globalErrorDescription": "We could not load this page safely. Please refresh and try again.",
    "globalErrorTitle": "Something went wrong",
    "homeSearchPlaceholder": "Search tools, AI tools, blog, and categories...",
    "howToUseFaqManageSettingsQuestion": "How can I manage platform settings?",
    "howToUseFaqSwitchLanguageAnswer": "Use the globe icon in the navbar. The page direction and translated content update instantly.",
    "howToUseFaqSwitchLanguageQuestion": "How do I switch language?",
    "howToUseFaqTitle": "FAQ",
    "level": "Level",
    "menuAiGames": "AI Games",
    "menuAiTools": "AI Tools",
    "menuCalculatorTools": "Calculator Tools",
    "menuExploreImageTools": "Explore image tools",
    "menuExplorePdfTools": "Explore PDF tools",
    "menuImageTools": "Image Tools",
    "menuPdfTools": "PDF Tools",
    "menuSearchTools": "Search inside menu...",
    "menuTextTools": "Text Tools",
    "menuToolsCategories": "Tool Categories",
    "menuUtilityTools": "Utility Tools",
    "months": "months",
    "next": "Next",
    "nextBirthday": "Next birthday",
    "ownerName": "Eslam Mamdouh",
    "paginationMorePages": "More pages",
    "previous": "Previous",
    "privacyLastUpdatedDate": "January 2025",
    "privacyThirdPartyGoogleAdsense": "Google AdSense",
    "privacyThirdPartyGoogleAnalytics": "Google Analytics",
    "reactionClickNow": "Tap now!",
    "reactionInitialMessage": "Tap start and wait for green",
    "reactionLatest": "Latest result",
    "reactionTooEarly": "Too early! Tap start to try again.",
    "reactionWaitMessage": "Wait for green...",
    "reactionYourTime": "Your time",
    "readSeoArticles": "Read SEO Articles",
    "relatedToolsHeading": "Related Tools",
    "routeLoadingPage": "Loading page...",
    "scrollToBottom": "Scroll to bottom",
    "scrollToTop": "Scroll to top",
    "search": "Search",
    "searchInputPlaceholder": "Search tools, AI tools, articles, and categories...",
    "searchNoResults": "No matching results. Try different keywords.",
    "searchResultsDescription": "Find tools, AI services, and content across 3ToolsPro.",
    "searchResultsTitle": "Search results",
    "searchSeeAllResults": "See all results",
    "searchShowingFor": "Showing results for \"{query}\"",
    "searchTypeArticle": "Article",
    "searchTypeToStart": "Type a keyword in the homepage search bar to start.",
    "seoAiDungeonDesc": "Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.",
    "seoAiDungeonTitle": "AI Dungeon Game Online | 3ToolsPro",
    "seoAiGuessTheCharacterDesc": "Play AI Guess The Character with instant clues and shareable results for social engagement.",
    "seoAiGuessTheCharacterTitle": "AI Guess The Character Game | 3ToolsPro",
    "seoAiQuizGameDesc": "Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.",
    "seoAiQuizGameTitle": "AI Quiz Game Online | 3ToolsPro",
    "seoAiRiddleGeneratorDesc": "Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.",
    "seoAiRiddleGeneratorTitle": "AI Riddle Generator | 3ToolsPro",
    "seoAiRoastMeDesc": "Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.",
    "seoAiRoastMeTitle": "AI Roast Me Game | 3ToolsPro",
    "seoAiStoryAdventureDesc": "Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.",
    "seoAiStoryAdventureTitle": "AI Story Adventure Game | 3ToolsPro",
    "seoTranslationToolDesc": "Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.",
    "seoTranslationToolTitle": "Real-time Translation Tool Online | 3ToolsPro",
    "toolAgeCalculate": "Calculate age",
    "toolAgeCalculatorSubtitle": "Find your exact age in years, months, and days.",
    "toolAgeEnterDate": "Enter your birth date",
    "toolAgeYourAge": "Your age",
    "toolTranslationTool": "Real-time Translation Tool",
    "totalDays": "Total days",
    "totalHours": "Total hours",
    "totalMinutes": "Total minutes",
    "totalMonths": "Total months",
    "totalWeeks": "Total weeks",
    "translationArticleP1": "This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.",
    "translationArticleTitle": "Why use this translation tool?",
    "translationBenefit1": "Fast live translation with debounced input.",
    "translationBenefit2": "Mobile-first interface designed for readability.",
    "translationBenefit3": "Session persistence keeps your last input locally.",
    "translationBenefitsTitle": "Benefits",
    "translationError": "Translation is temporarily unavailable. Please try again in a moment.",
    "translationFaqA1": "Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.",
    "translationFaqA2": "Only your last session is saved in localStorage on your device for better UX.",
    "translationFaqQ1": "Does it auto-detect language?",
    "translationFaqQ2": "Is my text stored on this website?",
    "translationFaqTitle": "Translation FAQ",
    "translationFrom": "From language",
    "translationHow1": "Choose source and target languages.",
    "translationHow2": "Type your text and wait for live translation.",
    "translationHow3": "Copy translated output or swap directions instantly.",
    "translationInputPlaceholder": "Type or paste text to translate...",
    "translationOutputPlaceholder": "Translation appears here instantly...",
    "translationSubtitle": "Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.",
    "translationSwap": "Swap languages",
    "translationTitle": "Real-time Translation Tool",
    "translationTo": "To language",
    "wordCounter.title": "Word Counter",
    "years": "years"
  }
};

export default translationAutofill;
